import { Injectable } from '@angular/core';
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { environment } from 'env/environment';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  public app: FirebaseApp;
  public auth: Auth;
  public firestore: Firestore;

  constructor() {
    // Initialize Firebase App
    this.app = initializeApp(environment.firebase);
    
    // Initialize Firebase services as needed
    this.auth = getAuth(this.app);
    this.firestore = getFirestore(this.app);
    
  }
}
